import { Action } from '@ngrx/store';
import { GeoCoordinate } from '@polaris-customerweb/sharedcomponents.shared';
import { Waypoint } from '@polaris-customerweb/sharedcomponents.user-content';

export const WaypointAction = {
    deleteWaypoint: '[waypoint] delete waypoint',
    forceWaypointRefresh: '[waypoint] refresh on next pull',
    setActivePublicWaypoint: '[waypoint] set active public waypoint',
    setActiveWaypoint: '[waypoint] set active waypoint',
    setEditableWaypoint: '[waypoint] set editable waypoint',
    setPublicWaypointsInView: '[waypoint] set public waypoints in view',
    setWaypoints: '[waypoint] set waypoints',
    toggleActiveWaypoint: '[waypoint] toggle active waypoint',
    updateEditableWaypointLocation:
        '[waypoint] update editable waypoint location',
    updatePublicWaypoint: '[waypoint] update public waypoint',
    updateWaypoint: '[waypoint] update waypoint',
};

export class DeleteWaypoint implements Action {
    type = WaypointAction.deleteWaypoint;
    constructor(public waypointId: string) {}
}

export class ForceWaypointRefresh implements Action {
    type = WaypointAction.forceWaypointRefresh;
    constructor(public forceRefresh: boolean) {}
}

export class SetActivePublicWaypoint implements Action {
    type = WaypointAction.setActivePublicWaypoint;
    constructor(public publicWaypoint: Waypoint | undefined) {}
}

export class SetActiveWaypoint implements Action {
    type = WaypointAction.setActiveWaypoint;
    constructor(public waypoint: Waypoint | undefined) {}
}

export class SetEditableWaypoint implements Action {
    type = WaypointAction.setEditableWaypoint;
    constructor(public waypoint: Waypoint | undefined) {}
}

export class SetPublicWaypointsInView implements Action {
    type = WaypointAction.setPublicWaypointsInView;
    constructor(public publicWaypoints: Waypoint[]) {}
}

export class SetWaypoints implements Action {
    type = WaypointAction.setWaypoints;
    constructor(public waypoints: Waypoint[]) {}
}

export class ToggleActiveWaypoint implements Action {
    type = WaypointAction.toggleActiveWaypoint;
    constructor(public waypoint: Waypoint | undefined) {}
}

export class UpdateEditableWaypointLocation implements Action {
    type = WaypointAction.updateEditableWaypointLocation;
    constructor(public geoCoordinate: GeoCoordinate) {}
}

export class UpdatePublicWaypoint implements Action {
    type = WaypointAction.updatePublicWaypoint;
    constructor(public publicWaypoint: Waypoint) {}
}

export class UpdateWaypoint implements Action {
    type = WaypointAction.updateWaypoint;
    constructor(public waypoint: Waypoint) {}
}
